export default __webpack_public_path__ + "static/media/geoServices.6f5a5354.svg";